import firebaseSrv from '@/services/firebaseSrv.js'
import _ from 'lodash/core'
import Vue from 'vue'
// import router from '@/router.js'
export const namespaced = true

export const state = {
  photos: {}
}
export const mutations = {
  PUSH_PHOTO(state, photoOb) {
    // console.log(photo)
    state.photos = Object.assign(photoOb, state.photos)
    // state.photos.push(photo)
  },
  GET_PHOTOS(state, photos) {
    state.photos = photos
  },
  DELETE_PHOTO(state, pid) {
    let newPhotoOb = { ...state.photos }
    delete newPhotoOb[pid]
    state.photos = newPhotoOb
  },
  UPDATE_PHOTO(state, payload) {
    if (typeof payload === 'object' && payload != null) {
      // console.log('payload is an object')
      // Vue.set() Inserts a new propery into an object
      Vue.set(state.photos[payload.pid], payload.key, payload.value)
    }
  }
}
export const actions = {
  // CREATE PHOTO
  createPhoto({ commit, state }, photo) {
    // console.log('photos eid:' + photo.eid)
    return firebaseSrv
      .createPhoto(photo)
      .then(() => {
        let photoOb = { [photo.pid]: photo }
        return commit('PUSH_PHOTO', photoOb)
      })
      .then(() => {
        commit('entry/UPDATE_PHOTOS', state.photos, { root: true })
      })
  },
  // DELETE PHOTOS
  deletePhoto({ commit }, photo) {
    firebaseSrv.deletePhoto(photo).then(() => {
      return Promise.all([
        commit('DELETE_PHOTO', photo.pid),
        commit('entry/DELETE_PHOTO', photo, { root: true })
      ])
    })
  },
  createGalleryThumb({ commit }, photo) {
    const path = `${photo.folderName}/gallery/thumb_gallery_${photo.fileName}`
    firebaseSrv
      .getImage(path)
      .then(url => {
        // console.log('Here:' + JSON.stringify(response))
        return commit('UPDATE_PHOTO', {
          eid: photo.eid,
          pid: photo.pid,
          key: 'galleryPath',
          value: url
        })
      })
      .catch(error => {
        return console.log(error)
      })
  },
  addGalleryPathToPhoto({ state }, payload) {
    // console.log('passed: ' + payload.galleryPath)
    firebaseSrv
      .addGalleryPathToPhoto(payload)
      // .then(() => console.log('it worked'))
      .catch(error => {
        return console.log('Error getting data:', error)
      })
  }
}
export const getters = {
  photoCount: state => {
    return Object.keys(state.photos).length
  },
  /* orderedPhotos: state => {
    return state.photos.slice().sort((a, b) => a.order - b.order)
  }, */

  photoSlides: state => {
    let slides = []
    const photos = _.values(state.photos)
    const orderedPhotos = photos.slice().sort((a, b) => a.pid - b.pid)
    orderedPhotos.forEach(photo => {
      let slide = {
        src: photo.filePath,
        w: photo.width,
        h: photo.height,
        ...photo
      }
      slides.push(slide)
    })
    return slides
  }
}
